namespace Core {

    class DateOrMonthPicker {
        show: boolean;
        value: Date;
        flexibility?: number;
        minimumDate: Date;

        constructor (
            $scope: ng.IScope,
            dateUtil: any
        ) {
            this.minimumDate = dateUtil.todayPlus(1);
        }
    }

    angular
        .module('core')
        .directive('dateOrMonthPicker', (): ng.IDirective => ({
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=DateOrMonthPicker',
            controller: DateOrMonthPicker,
            controllerAs: 'cm',
            bindToController: {
                show: '=',
                value: '=',
                flexibility: '=',
            },
            scope: {},
        }));
}
